import { BACKEND_ROUTES } from "../../../backendRoutes";

/**
 * Fetches the bounding box of a coverage layer via the backend
 * (which proxies to GeoServer's REST API).
 *
 * @param {string} layerName - The full layer name (e.g. "hcc:uuid-plain")
 * @param {Function} get - The get method from useFetch()
 * @returns {Promise<[[number, number], [number, number]]>} Leaflet-compatible bounds [[south, west], [north, east]]
 */
export async function fetchWMSLayerBounds(layerName, get) {
    const colonIndex = layerName.indexOf(":");
    const workspace =
        colonIndex !== -1 ? layerName.substring(0, colonIndex) : null;
    const name =
        colonIndex !== -1 ? layerName.substring(colonIndex + 1) : layerName;

    if (!workspace) {
        throw new Error(
            `Layer name "${layerName}" must include a workspace prefix`
        );
    }

    const data = await get(
        `${BACKEND_ROUTES.GEOSERVER_COVERAGE_BOUNDS}/${workspace}/${encodeURIComponent(name)}`,
        { forwardError: true }
    );

    if (!data.miny || !data.minx || !data.maxy || !data.maxx) {
        throw new Error(
            `Layer "${layerName}" doesn't exist or cannot be accessed`
        );
    }

    return [
        [data.miny, data.minx],
        [data.maxy, data.maxx],
    ];
}
